import { render, staticRenderFns } from "./bottomBar.vue?vue&type=template&id=458f4a08&scoped=true&"
import script from "./bottomBar.vue?vue&type=script&lang=js&"
export * from "./bottomBar.vue?vue&type=script&lang=js&"
import style0 from "./bottomBar.vue?vue&type=style&index=0&id=458f4a08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458f4a08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('458f4a08')) {
      api.createRecord('458f4a08', component.options)
    } else {
      api.reload('458f4a08', component.options)
    }
    module.hot.accept("./bottomBar.vue?vue&type=template&id=458f4a08&scoped=true&", function () {
      api.rerender('458f4a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bottomBar.vue"
export default component.exports